/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({}, payload) {
    const url = `/kalender?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  async detail({}, payload) {
    const url = `/kalender/${payload}`;
    return await http.get(url).then(({ data }) => data);
  },

  create({}, payload) {
    const url = `/kalender`;
    return http.post(url, payload.params);
  },

  update({}, payload) {
    const url = `/kalender/${payload.id}`;
    return http.patch(url, payload.params);
  },

  status({}, payload) {
    const url = `/kalender/${payload.id}/${payload.status}`;
    return http.post(url);
  },

  delete({}, payload) {
    const url = `/kalender/${payload.id}`;
    return http.delete(url);
  },
};
